/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_MCO_CLAIMS_SEARCH_OBJ = 'GET_MCO_CLAIMS_SEARCH_OBJ';
export const IS_LOADING = 'IS_LOADING';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_MCO_CLAIMS_DISPLAY = 'REFRESH_MCO_CLAIMS_DISPLAY';
export const GET_ERROR_MSG_MCO_CLAIMS = 'GET_ERROR_MSG_MCO_CLAIMS';
export const SET_MANUFACTURERS_LIST = 'SET_MANUFACTURERS_LIST';
export const DISPATCH_ALL_MFG_CHECKED = 'DISPATCH_ALL_MFG_CHECKED';
export const SET_MCO_CLAIMS_DATA = 'SET_MCO_CLAIMS_DATA';
export const DISPLAY_URA_TYPE = 'DISPLAY_URA_TYPE';
export const DISPATCH_QTR_VALUE = 'DISPATCH_QTR_VALUE';
export const SELECT_OPTION = 'SELECT_OPTION';
export const GET_MANUFACTURER_NAME_ACT = 'GET_MANUFACTURER_NAME_ACT';
export const GET_MANUFACTURER_ID_ACT = 'GET_MANUFACTURER_ID_ACT';
export const SET_REBATE_PROGRAM = 'SET_REBATE_PROGRAM';
export const REFRESH_MCO_CLAIMS = 'REFRESH_MCO_CLAIMS';
export const SET_DISPLAY_OBJ_MCO_CLAIMS = 'SET_DISPLAY_OBJ_MCO_CLAIMS';
